import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';

const ontologyMaster = {
  fetchOntologyList: async (token: string) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.SITE_ONTOLOGY_LEVELS_URL);

      let res: any = apiResponse.data;      
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchOntologyAccess: async (token: string) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.SITE_ONTOLOGY_LEVELS_URL + '/access/is_editable');

      let res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  saveOntology: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.post(apiPath.SITE_ONTOLOGY_LEVELS_URL, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: { payload, res },
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateLevelMaster: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.put(apiPath.SITE_ONTOLOGY_LEVELS_URL, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: { payload, res },
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addOntologyMaster: async (payload: any) => {
    try {
      let reqParams = {
        onto_manage_title: payload.onto_manage_title,
        parent_id: payload.parent_id,
      };
      const apiResponse = await axiosClient.post(
        apiPath.SITE_ONTOLOGY_MASTER_URL + '?onto_level_id=' + payload.onto_level_id,
        reqParams
      );
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateOntologyMaster: async (payload: any) => {
    try {
      let reqParams = {
        onto_manage_title: payload.onto_manage_title,
      };
      const apiResponse = await axiosClient.patch(
        apiPath.SITE_ONTOLOGY_MASTER_URL + '/' + payload.onto_manage_id,
        reqParams
      );

      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  getAllOntologies: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.SITE_ONTOLOGY_MASTER_URL);
      let res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  getFactoriesOntologies: async () => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.SITE_ONTOLOGY_MASTER_URL + '/ontologies');
      return {
        status: 'success',
        code: apiResponse?.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default ontologyMaster;
